import { AxiosInstance } from 'axios';

import { T_LeadsNature, T_Notification, T_StaticJson } from '../types';

export class NotificationService {
  private notifAgent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.notifAgent = agent;
  }
  public getNotifications = async () => {
    try {
      const { data } = await this.notifAgent.get<T_Notification>(`/my-account/notification`, {});
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  public getLeads = async () => {
    try {
      const { data } = await this.notifAgent.get<T_LeadsNature>(`/my-account/lead`, {});
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  public getStaticJson = async () => {
    try {
      const { data } = await this.notifAgent.get<T_StaticJson[]>(`/my-account/static-json`, {});
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };
}
